export const clampCropRect = (rect, stageWidth, stageHeight, aspectRatio) => {
  let { x, y, width, height } = rect;

  const maxStageWidth = Math.max(20, stageWidth);
  const maxStageHeight = Math.max(20, stageHeight);

  width = Number.isFinite(width) ? width : 20;
  height = Number.isFinite(height) ? height : 20;
  x = Number.isFinite(x) ? x : 0;
  y = Number.isFinite(y) ? y : 0;

  width = Math.max(20, width);
  height = Math.max(20, height);

  if (aspectRatio) {
    height = Math.min(height, maxStageHeight);
    width = height * aspectRatio;

    if (width > maxStageWidth) {
      width = maxStageWidth;
      height = width / aspectRatio;
    }

    if (height > maxStageHeight) {
      height = maxStageHeight;
      width = height * aspectRatio;
    }
  } else {
    width = Math.min(width, maxStageWidth);
    height = Math.min(height, maxStageHeight);
  }

  width = Math.min(width, maxStageWidth);
  height = Math.min(height, maxStageHeight);

  x = Math.max(0, Math.min(x, stageWidth - width));
  y = Math.max(0, Math.min(y, stageHeight - height));

  return {
    x,
    y,
    width: Math.max(20, width),
    height: Math.max(20, height),
  };
};
